window.addEventListener('options:rendered', function (e) {
    const button = document.querySelector('.finish-config');
    let previewDiv = null;

    function togglePreviewLock(lock) {
        if (previewDiv) {
            previewDiv.style.pointerEvents = lock ? 'none' : 'auto';
        } else {
            console.error('Vorschau-Div nicht vorhanden. Sperrung konnte nicht ausgeführt werden.');
        }
    }

    function toggleVisibility() {
        const configDivs = document.querySelectorAll(
            '[data-option="colorswatch"],' +
           '[data-option="Grafiker"],' +
            '[data-option="Druckflächen"],' +
            '[data-option="Druckfarben"],' +
            '[data-option="Klischee"],' +
            '[data-option="Klischee 2-Farbig"],' +
            '[data-option="Klischee 3-Farbig"],' +
            '[data-option="Klischee 4-Farbig"],' +
            '[data-option="Bilderupload Vorderseite"],' +
            '[data-option="Bilderupload Rückseite"],' +
            '[data-option="Bilderupload"],' +
            '[data-option="Texte"],' +
            '[data-option="Hinweis"],' +
            '[data-option="Text Vorderseite"],' +
            '[data-option="Text Rückseite"],' +
            '[data-option="Mengenauswahl"]'
        );

        configDivs.forEach(div => div.classList.toggle('config-hide'));
    }

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && node.classList.contains('cl-po--preview')) {
                    previewDiv = node;
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    button.addEventListener('click', () => {
        toggleVisibility();
        if (button.textContent.trim() === 'Konfiguration abschließen') {
            button.textContent = 'Konfiguration öffnen';
            togglePreviewLock(true);

            // Mouseup-Event auf die .cl-po--canvas auslösen
            document.querySelectorAll('.cl-po--canvas').forEach(element => {
                const mouseupEvent = new MouseEvent('mousedown', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                element.dispatchEvent(mouseupEvent);
            });
        } else {
            button.textContent = 'Konfiguration abschließen';
            togglePreviewLock(false);

            const canvasElement = document.querySelector('.cl-po--canvas');
            if (canvasElement) {
                canvasElement.click();
            }
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}, { once: true });
